import {NgModule} from '@angular/core';

import {AsyncPipe, CommonModule} from '@angular/common';
import {ProjectsListComponent} from '@app/welfy-plugin/welfy/calculator/projects-list/projects-list.component';
import {NbAccordionModule, NbActionsModule, NbAlertModule, NbBadgeModule, NbButtonModule, NbCalendarModule, NbCalendarRangeModule, NbCardModule, NbChatModule, NbCheckboxModule, NbContextMenuModule, NbDatepickerModule, NbDialogService, NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbMenuModule, NbMenuService, NbOverlayModule, NbProgressBarModule, NbRadioModule, NbSelectModule, NbSidebarModule, NbSidebarService, NbSpinnerModule, NbStepperModule, NbTabsetModule, NbToastrModule, NbToastrService, NbToggleModule, NbTooltipModule, NbUserModule, NbWindowModule, NbWindowService} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProductComponent} from './product/product.component';
import {LifeProjectsComponent} from './life-projects/life-projects.component';
import {NbMomentDateModule} from '@nebular/moment';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {WelfareResultService} from '../service/welfare-result.service';
import {SimpleMessageDialogComponent} from './dialog/simple-message-dialog/simple-message-dialog.component';
import {DialogInputComponent} from './dialog-input/dialog-input.component';
import {SimulationTypeDialogComponent} from './dialog/simulation-type-dialog/simulation-type-dialog.component';
import {PdfViewerComponentComponent} from './pdf-viewer-component/pdf-viewer-component.component';
import {InvalidProjectDialogComponent} from './dialog/invalid-project-dialog/invalid-project-dialog.component';
import {ConfirmMessageDialogComponent} from './dialog/confirm-message-dialog/confirm-message-dialog.component';
import {CalculatorComponent} from '@app/welfy-plugin/welfy/calculator/calculator.component';
import {DesktopComponent} from '@app/welfy-plugin/welfy/calculator/desktop/desktop.component';
import {PersonRowComponent} from './person-row/person-row.component';
import {InserimentoDatiComponent} from '@app/welfy-plugin/welfy/calculator/inserimento-dati/inserimento-dati.component';
import {DebtComponent} from './debt/debt.component';
import {ResultComponent} from '@app/welfy-plugin/welfy/calculator/result/result.component';
import {AssetHomeComponent} from './asset-home/asset-home.component';
import {AssetFinancingComponent} from './asset-financing/asset-financing.component';
import {BaseResultComponent} from './result/base-result/base-result.component';
import {IncomeComponent} from './income/income.component';
import {AssetResultComponent} from './result/asset-result/asset-result.component';
import {DebtsResultComponent} from './result/debts-result/debts-result.component';
import {IncomeResultComponent} from './result/income-result/income-result.component';
import {UniversityEditorComponent} from './life-projects/editors/university-editor/university-editor.component';
import {BoardComponentComponent} from './life-projects/editors/board-component/board-component.component';
import {FinatialComponent} from './life-projects/editors/finatial/finatial.component';
import {LifeProjectResultComponent} from './result/life-project-result/life-project-result.component';
import {UniversityViewComponent} from './result/life-project-result/project-view/university-view/university-view.component';
import {SafeguardComponent} from './result/safeguard/safeguard.component';
import {BadEventListComponent} from './result/safeguard/bad-event-list/bad-event-list.component';
import {AssetRiskComponent} from './result/safeguard/asset-risk/asset-risk.component';
import {BoardViewComponent} from './result/life-project-result/project-view/board-view/board-view.component';
import {BuildMoneyComponent} from './life-projects/editors/build-money/build-money.component';
import {FinantialViewComponent} from './result/life-project-result/project-view/finantial-view/finantial-view.component';
import {BuildMoneyViewComponent} from './result/life-project-result/project-view/build-money-view/build-money-view.component';
import {AssetOtherComponent} from './asset-other/asset-other.component';
import {WelfareChartComponent} from './result/charts/welfare-chart/welfare-chart.component';
import {WelfarePipeChartComponent} from './result/charts/welfare-pipe-chart/welfare-pipe-chart.component';
import {PrevAreaComponent} from '@app/welfy-plugin/welfy/calculator/prev-area/prev-area.component';
import {SafeguardQuoteComponent} from './quote/safeguard-quote/safeguard-quote.component';
import {QuoteRowComponent} from './quote/safeguard-quote/quote-row/quote-row.component';
import {SafeGuardPrizeComponent} from './quote/safe-guard-prize/safe-guard-prize.component';
import {AssetRiskQuoteComponent} from './quote/asset-risk-quote/asset-risk-quote.component';
import {AssetRiskRowComponent} from './quote/asset-risk-quote/asset-risk-row/asset-risk-row.component';
import {QuoteChartComponent} from './quote/quote-chart/quote-chart.component';
import {RSCQuoteComponent} from './quote/rscquote/rscquote.component';
import {ServiceQuoteComponent} from './quote/service-quote/service-quote.component';
import {ServiceQuoteRowComponent} from './quote/service-quote/service-quote-row/service-quote-row.component';
import {RCSQuoteRowComponent} from './quote/rscquote/rcsquote-row/rcsquote-row.component';
import {AssetManagementComponent} from './life-projects/editors/asset-management/asset-management.component';
import {AssetResourcesComponent} from './life-projects/editors/asset-resources/asset-resources.component';
import {AssetRowComponent} from './life-projects/editors/asset-resources/asset-row/asset-row.component';
import {AssetResourceRowComponent} from './life-projects/editors/asset-management/asset-resource-row/asset-resource-row.component';
import {AssetEditorComponent} from './life-projects/editors/asset-management/asset-editor/asset-editor.component';
import {ResourceListComponent} from './life-projects/editors/asset-management/resource-list/resource-list.component';
import {IncomeRepartitionComponent} from './result/income-repartition/income-repartition.component';
import {PersonButtonComponent} from './person-button/person-button.component';
import {MoneyBuilderEditorComponent} from './editors/money-builder-editor/money-builder-editor.component';
import {SafeGuardInfoComponent} from './result/safeguard/safe-guard-info/safe-guard-info.component';
import {LifeProjectBaseEditorComponent} from './life-projects/editors/life-project-base-editor/life-project-base-editor.component';
import {ArchiveComponent} from '@app/welfy-plugin/welfy/calculator/archive/archive.component';
import {ReportPrinterComponent} from './report/report-printer/report-printer.component';
import {SaveDialogComponent} from './dialog/save-dialog/save-dialog.component';
import {PersonIncomeComponentComponent} from './person-income-component/person-income-component.component';
import {SearchPipe} from '../pipe/search.pipe';
import {EphesoComponent} from './life-projects/editors/board-component/epheso/epheso.component';
import {RetirementTypeChooserDialogComponent} from './dialog/retirement-type-chooser-dialog/retirement-type-chooser-dialog.component';
import {SimpleRetirmentComponent} from './life-projects/editors/board-component/simple-retirment/simple-retirment.component';
import {EphesoJobChooserComponent} from './dialog/epheso-job-chooser/epheso-job-chooser.component';
import {UsegeConditionDialogComponent} from './dialog/usege-condition-dialog/usege-condition-dialog.component';
import {WelfyProProjectListComponent} from './welfy-project-list/welfy-pro-project-list.component';
import {WelfySimpleProjectResultComponent} from './welfy-simple-project-result/welfy-simple-project-result.component';
import {PersonChooserDialogComponent} from './dialog/person-chooser-dialog/person-chooser-dialog.component';
import {PersonChooserComponent} from './person-chooser/person-chooser.component';
import {SafeGuardCardComponent} from './result/safeguard/safe-guard-card/safe-guard-card.component';
import {WelfyConfigService} from '../service/welfy-config.service';
import {LoadingDialogComponent} from './dialog/loading-dialog/loading-dialog.component';
import {UserFormatterPipe} from '../pipe/user-formatter.pipe';
import {ProductsDialogComponent} from './dialog/products-dialog/products-dialog.component';
import {AttachmentsComponent} from './attachments/attachments.component';
import {AttachmentuploaderComponent} from './attachmentuploader/attachmentuploader.component';
import {FileReferenceDialogComponent} from './dialog/file-reference-dialog/file-reference-dialog.component';
import {LifeProjectTabComponent} from './life-projects/life-project-tab/life-project-tab.component';
import {ImportCollaboratorDialogComponent} from './dialog/import-collaborator-dialog/import-collaborator-dialog.component';
import {InputDialogComponent} from './dialog/input-dialog/input-dialog.component';
import {SearchCustomerDialogComponent} from './dialog/search-customer-dialog/search-customer-dialog.component';
import {SearchBoxComponent} from './search-box/search-box.component';
import {AttachmentComponent} from './attachment/attachment.component';
import {AdvanceRetirementComponent} from './life-projects/editors/board-component/advance-retirement/advance-retirement.component';
import {TableFilterPipe} from '../pipe/table-filter.pipe';
import {PrivacyLogActionComponent} from './privacy/privacy-log-action/privacy-log-action.component';
import {FieldEditorDialogComponent} from './dialog/input-dialog/field-editor-dialog/field-editor-dialog.component';
import {AddressComponent} from './address/address.component';
import {AddressEditorComponent} from './address/address-editor/address-editor.component';
import {ContactComponent} from './contact/contact.component';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTabsModule} from '@angular/material/tabs';
import {WelfyTable} from './welfy-table/welfy-table';
import {DataPropertyGetterPipe} from './welfy-table/data-property-getter.pipe';
import {MatCardModule} from '@angular/material/card';

@NgModule({
  declarations: [
    TableFilterPipe,
    ImportCollaboratorDialogComponent,
    ProjectsListComponent,
    ProductComponent,
    LifeProjectsComponent,
    CalculatorComponent,
    DesktopComponent,
    PersonRowComponent,
    InserimentoDatiComponent,
    DebtComponent,
    ResultComponent,
    AssetHomeComponent,
    AssetFinancingComponent,
    DialogInputComponent,
    BaseResultComponent,
    IncomeComponent,
    AssetResultComponent,
    DebtsResultComponent,
    IncomeResultComponent,
    UniversityEditorComponent,
    BoardComponentComponent,
    FinatialComponent,
    LifeProjectResultComponent,
    UniversityViewComponent,
    SafeguardComponent,
    BadEventListComponent,
    AssetRiskComponent,
    BoardViewComponent,
    BuildMoneyComponent,
    FinantialViewComponent,
    BuildMoneyViewComponent,
    AssetOtherComponent,
    WelfareChartComponent,
    SimulationTypeDialogComponent,
    WelfarePipeChartComponent,
    PrevAreaComponent,
    SafeguardQuoteComponent,
    QuoteRowComponent,
    SafeGuardPrizeComponent,
    AssetRiskQuoteComponent,
    AssetRiskRowComponent,
    QuoteChartComponent,
    RSCQuoteComponent,
    ServiceQuoteComponent,
    ServiceQuoteRowComponent,
    RCSQuoteRowComponent,
    AssetManagementComponent,
    AssetResourcesComponent,
    AssetRowComponent,
    AssetResourceRowComponent,
    AssetEditorComponent,
    ResourceListComponent,
    IncomeRepartitionComponent,
    PersonButtonComponent,
    MoneyBuilderEditorComponent,
    SafeGuardInfoComponent,
    LifeProjectBaseEditorComponent,
    PdfViewerComponentComponent,
    ArchiveComponent,
    ReportPrinterComponent,
    InvalidProjectDialogComponent,
    SaveDialogComponent,
    PersonIncomeComponentComponent,
    ConfirmMessageDialogComponent,
    SimpleMessageDialogComponent,
    SearchPipe,
    EphesoComponent,
    RetirementTypeChooserDialogComponent,
    SimpleRetirmentComponent,
    EphesoJobChooserComponent,
    UsegeConditionDialogComponent,
    WelfyProProjectListComponent,
    WelfySimpleProjectResultComponent,
    PersonChooserDialogComponent,
    PersonChooserComponent,
    SafeGuardCardComponent,
    LoadingDialogComponent,
    UserFormatterPipe,
    ProductsDialogComponent,
    AttachmentsComponent,
    AttachmentuploaderComponent,
    FileReferenceDialogComponent,
    LifeProjectTabComponent,
    InputDialogComponent,
    SearchCustomerDialogComponent,
    SearchBoxComponent,
    AttachmentComponent,
    AdvanceRetirementComponent,
    PrivacyLogActionComponent,
    FieldEditorDialogComponent,
    AddressComponent,
    AddressEditorComponent,
    ContactComponent,
    WelfyTable,
    DataPropertyGetterPipe,
  ],
  imports: [
    CommonModule,
    NbCardModule,
    NbIconModule,
    NbEvaIconsModule,
    RouterModule,
    RouterModule, // RouterModule.forRoot(routes, { useHash: true }), if this is your apps.module
    NbLayoutModule,
    NbSidebarModule, // NbSidebarModule.forRoot(), //if this is your apps.module
    NbButtonModule,
    NbCardModule,
    NbTabsetModule,
    NbInputModule,
    NbCalendarModule,
    FormsModule,
    NbSelectModule,
    NbStepperModule,
    NbIconModule,
    NbTooltipModule,
    NbActionsModule,
    NbCheckboxModule,
    NbOverlayModule,
    NbListModule,
    NbWindowModule.forChild(),
    NbRadioModule,
    NbSidebarModule,
    NbSpinnerModule,
    NbAccordionModule,
    NbAlertModule,
    NbDatepickerModule,
    NbIconModule,
    PdfViewerModule,
    NbMenuModule,
    NbLayoutModule,
    NbSidebarModule,
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbUserModule,
    NbContextMenuModule,
    NbEvaIconsModule,
    NbBadgeModule,
    NbCalendarRangeModule,
    ReactiveFormsModule,
    NbProgressBarModule,
    NbToggleModule,
    NbChatModule,
    NbToastrModule.forRoot(),
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbToggleModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatCardModule,
  ],
  exports: [
    AddressComponent,
    ContactComponent,
    ImportCollaboratorDialogComponent,
    ReactiveFormsModule,
    NbBadgeModule,
    NbCardModule,
    NbIconModule,
    NbEvaIconsModule,
    RouterModule,
    FormsModule,
    RouterModule, // RouterModule.forRoot(routes, { useHash: true }), if this is your apps.module
    NbLayoutModule,
    NbSidebarModule, // NbSidebarModule.forRoot(), //if this is your apps.module
    NbButtonModule,
    NbCardModule,
    NbTabsetModule,
    NbInputModule,
    NbCalendarModule,
    NbSelectModule,
    NbStepperModule,
    NbIconModule,
    NbTooltipModule,
    NbActionsModule,
    NbCheckboxModule,
    NbOverlayModule,
    NbListModule,
    NbRadioModule,
    NbSidebarModule,
    NbSpinnerModule,
    NbAccordionModule,
    NbAlertModule,
    NbDatepickerModule,
    NbMomentDateModule,
    NbIconModule,
    PdfViewerModule,
    NbMenuModule,
    NbLayoutModule,
    NbSidebarModule,
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbUserModule,
    NbContextMenuModule,
    NbEvaIconsModule,
    NbCardModule,
    NbToggleModule,
    ProjectsListComponent,
    ProductComponent,
    LifeProjectsComponent,
    CalculatorComponent,
    DesktopComponent,
    PersonRowComponent,
    InserimentoDatiComponent,
    DebtComponent,
    ResultComponent,
    AssetHomeComponent,
    AssetFinancingComponent,
    DialogInputComponent,
    BaseResultComponent,
    IncomeComponent,
    AssetResultComponent,
    DebtsResultComponent,
    IncomeResultComponent,
    UniversityEditorComponent,
    BoardComponentComponent,
    FinatialComponent,
    LifeProjectResultComponent,
    UniversityViewComponent,
    SafeguardComponent,
    BadEventListComponent,
    AssetRiskComponent,
    BoardViewComponent,
    BuildMoneyComponent,
    FinantialViewComponent,
    BuildMoneyViewComponent,
    AssetOtherComponent,
    WelfareChartComponent,
    SimulationTypeDialogComponent,
    WelfarePipeChartComponent,
    PrevAreaComponent,
    SafeguardQuoteComponent,
    QuoteRowComponent,
    SafeGuardPrizeComponent,
    AssetRiskQuoteComponent,
    AssetRiskRowComponent,
    QuoteChartComponent,
    RSCQuoteComponent,
    ServiceQuoteComponent,
    ServiceQuoteRowComponent,
    RCSQuoteRowComponent,
    AssetManagementComponent,
    AssetResourcesComponent,
    AssetRowComponent,
    AssetResourceRowComponent,
    AssetEditorComponent,
    ResourceListComponent,
    IncomeRepartitionComponent,
    PersonButtonComponent,
    MoneyBuilderEditorComponent,
    SafeGuardInfoComponent,
    LifeProjectBaseEditorComponent,
    PdfViewerComponentComponent,
    ArchiveComponent,
    ReportPrinterComponent,
    InvalidProjectDialogComponent,
    SaveDialogComponent,
    PersonIncomeComponentComponent,
    ConfirmMessageDialogComponent,
    SimpleMessageDialogComponent,
    SearchPipe,
    WelfyProProjectListComponent,
    PersonChooserComponent,
    UserFormatterPipe,
    NbCalendarRangeModule,
    AttachmentsComponent,
    AttachmentuploaderComponent,
    SearchBoxComponent,
    PrivacyLogActionComponent,
    WelfyTable,
    MatCardModule,
  ],
  providers: [
    NbToastrService,
    NbDialogService,
    NbSidebarService,
    NbWindowService,
    WelfareResultService,
    NbMenuService,
    WelfyConfigService,
    AsyncPipe,
  ],
})
export class SharedModule {

}
